export default "/images/9b557856004c9773484d0508e73e9b7e.avif";